import { cva } from '@/styled-system/css';

export const toggleCardHeaderRecipe = cva({
  base: {
    'marginBlockEnd': 'ToggleCard.Header.margin.to-Body',

    '& > [data-c11n-component="Heading"]': {
      textStyle: 'heading-xs',
    },
  },
  variants: {
    divider: {
      true: {
        paddingBlockEnd: 'ToggleCard.Header.padding.from-Header',
        borderBlockEndWidth: 'ToggleCard.Header',
        borderBlockEndStyle: 'solid',
        borderBlockEndColor: 'ToggleCard.Header.border',
      },
      false: {},
    },
  },
});
